import Keycloak from 'keycloak-js';
import axios from 'axios';

import { epicaIdentify } from '../../../features/epica';

const keycloak = new Keycloak("/keycloak.json");
const state = () => ({
    userBasic: null,
    news: null,
    hasLoaded: false,
    token: null
});


const getters = {
    user: (state) => {
        return state.userBasic ? {
            completeName: state.userBasic.completeName,
            email: state.userBasic.email,
            isSubscriber: state.userBasic.isSubscriber,
            printName: state.userBasic.printName,
            subscriberId: state.userBasic.subscriberId
        } : null;
    },
    favorites: (state) => {
        return state.userBasic ? state.userBasic.favorites : null;
    },
    topics: (state) => {
        return state.userBasic ? state.userBasic.topics : null;
    },
    news: (state) => {
        return state.news;
    },
    hasLoaded: (state) => {
        return state.hasLoaded;
    },
    token: (state) => {
        return state.token;
    }
};

const actions = {
    init({
        dispatch
    }) {
        keycloak.onAuthLogout = () => {
            dispatch('logout');
        }
    },
    checkSso() {
        return keycloak.init({
            onLoad: "check-sso",
            silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
            silentCheckSsoFallback: false
        })
    },
    getUserBasic({
        dispatch,
        commit
    }) {
        dispatch('checkSso').then(() => {
            if (keycloak.authenticated) {
                commit('setToken', keycloak.token);
                const axiosConfig = {
                    headers: {
                        Authorization: `Bearer ${keycloak.token}`
                    }
                };
                axios.get("/api/user", axiosConfig).then(function (d) {
                    commit('setUserBasic', d.data);
                    commit("loadEnd");
                });
            } else {
                commit("loadEnd");
            }
        });

        setTimeout(() => {
            commit("loadEnd");
        }, 5000);
    },
    getUserNews({
        commit,
        dispatch
    }) {
        dispatch('checkSso').then(() => {
            if (keycloak.authenticated) {
                commit('setToken', keycloak.token);
                const axiosConfig = {
                    headers: {
                        Authorization: `Bearer ${keycloak.token}`
                    }
                };
                const req1 = axios.get("/api/user", axiosConfig);
                const req2 = axios.get("/api/user/news", axiosConfig);
                axios.all([req1, req2]).then(axios.spread((...resp) => {
                    commit('setUserBasic', resp[0].data);
                    commit('setUserNews', resp[1].data);
                    commit("loadEnd");
                }))
            } else {
                commit("loadEnd");
            }
        });
        setTimeout(() => {
            commit("loadEnd");
        }, 5000);
    },
    login() {
        const loginUrl = keycloak.createLoginUrl();
        document.location.href = loginUrl;
    },
    logout() {
        keycloak.logout({
            redirectUrl: document.location.href
        });
    },
    addFavorite({ commit }, favorite) {
        if (keycloak.authenticated) {
            commit("addFavorite", favorite);
        }
    },
    addTopic({ commit }, topic) {
        if (keycloak.authenticated) {
            commit("addTopic", topic);
        }
    },
    removeFavorite({ commit }, id) {
        if (keycloak.authenticated) {
            commit("removeFavorite", id);
        }
    },
    subscribeUser({ commit, getters }, id) {
        debugger;
        if (keycloak.authenticated && !getters.user.subscriberId) {
            commit("subscribe", id);
        }
    }
};

const mutations = {
    addFavorite(state, favorite) {
        state.userBasic.favorites = state.userBasic.favorites ? state.userBasic.favorites : [];
        state.userBasic.favorites.push(favorite);
    },
    addTopic(state, topic) {
        state.userBasic.topics = state.userBasic.topics ? state.userBasic.topics : [];
        state.userBasic.topics.push(topic);
    },
    removeFavorite(state, id) {
        state.userBasic.favorites = state.userBasic.favorites.filter((q) => q.postId != id);
    },
    setUserBasic(state, userBasic) {
        epicaIdentify(userBasic.epicaUser);
        state.userBasic = userBasic;
    },
    setUserNews(state, userNews) {
        state.news = userNews;
    },
    setToken(state, token) {
        state.token = token;
    },
    subscribe(state, id) {
        state.userBasic.subscriberId = id;
        state.userBasic.isSubscriber = true;
    },
    loadEnd(state) {
        state.hasLoaded = true;
    }
};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}